import React from 'react';

import { DOCUMENT_TYPES } from '~constants/common';

import { useToast } from '~libs/toast';

import { AsyncActionIcon } from '~components';
import { faFilePdf } from '~components/icon';
import { useDocumentBatchGeneration } from '~main/components/document-batch-jobs/useDocumentBatchGeneration';

interface ComponentProps {
  id: string;
}

const ExportBudgetToPDF: React.FC<ComponentProps> = ({ id }) => {
  const { generateSeparate, isGenerating } = useDocumentBatchGeneration();
  const { showToast } = useToast();

  const handleGeneratePdf = async () => {
    try {
      await generateSeparate(DOCUMENT_TYPES.SAH_BUDGET.SINGLE, [id]).unwrap();
      showToast('success', 'Budget PDF generation started');
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to start budget PDF generation';
      showToast('danger', message);
    }
  };

  return (
    <AsyncActionIcon
      id="export-budget-pdf-icon"
      icon={faFilePdf}
      toolTip="Export To PDF"
      onClick={handleGeneratePdf}
      disabled={isGenerating || !id}
      successTitle="Budget PDF generation started"
      spinnerDataCy="budget-generate-pdf-spinner"
    />
  );
};

export default ExportBudgetToPDF;
